module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_is-object.js
// module id = 11
// module chunks = 2 3 4 5 6 7 8 9 10 11 12